module.exports = "/_next/static/resources/woman-2-d8f46713d19c210ac9c17e0eea66d7b8.webp";